module.exports = __webpack_public_path__ + "img/15-03_Communicating Well (Verbally).263bf8f2.svg";